module.exports = __webpack_public_path__ + "static/media/Bathroom.c9c4fe4c.png";